import { Component, Input } from "@angular/core";

import { EarningDataCard } from "@bitwarden/web-vault/app/models/types/component.types";
import { InstitutionInterest } from "@bitwarden/web-vault/app/models/types/institution.type";

import { accountLabel } from "../best-scenario.utils";

@Component({
  selector: "best-scenario-carousel-item",
  templateUrl: "./best-scenario-carousel-item.component.html",
})
export class BestScenarioCarouselItemComponent {
  @Input() accountBank?: string;
  @Input() accountName: string;
  @Input() earningsCard: EarningDataCard;
  @Input() rateInUse: InstitutionInterest;

  get label(): string {
    return accountLabel(this.accountBank, this.accountName);
  }
}
